import React from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import styles from "./notification.module.css";
import { Button } from "../../common/button";
import { ReactComponent as NotificationsIcon } from "../../../media/icons/notifications.svg";
import { PopupNotification } from "../popups/notification";

export const Notification = ({ onCloseHandler, popup }) => {
  const { t } = useTranslation();
  const { unread_notifications: unreadNotifications } = useSelector(state => state.account.profile);

  return (
    <div className={cn(styles.notificationWrap, Number(unreadNotifications) > 0 ? styles.counterNotification : null)}>
      <Button
        className={cn("button--clear", styles.popup)}
        onClick={onCloseHandler}
        aria-label={t("dashboard_nav_notifications")}
        aria-expanded={popup === "notification"}
      >
        <NotificationsIcon aria-hidden="true" focusable="false" />
      </Button>
      {popup === "notification" && <PopupNotification onCloseHandler={onCloseHandler} />}
    </div>
  );
};
